import { SelectItem } from '../types';
import { LoadOptions } from '../../types';
import { optionTypes } from 'ui/common/select/constants';

const haveNotFoundSelectedOption = (returnedOptions: SelectItem[], originOptions: SelectItem[]) => {
  return !returnedOptions?.length && !!originOptions?.length;
};

interface OptionsToHierarchyParams {
  originOptions: SelectItem[];
  loadOptions: LoadOptions;
  descriptionAllLevels: boolean;
  linkType?: optionTypes;
}

export const optionsToHierarchy = ({ 
  originOptions, loadOptions, descriptionAllLevels, linkType 
}: OptionsToHierarchyParams) => {
  
  const { parentId, siblingId } = loadOptions;
  const breadcrumbStack = [];
  let returnedOptions = [];
  let allLevelsDescriptionPrefix = '';
  
  const findOptionsAndBuildBreadcrumbStack = (addParentItemToStack: () => void, parentItem: SelectItem, items: SelectItem[]) => {
    const buildStack = () => {
      if (addParentItemToStack !== undefined) {
        breadcrumbStack.unshift(parentItem);
        addParentItemToStack();
      }
    };

    for (let i = 0; i < items.length; i++) {
      const item = {...items[i], type: linkType};

      if (item.value === parentId) {
        breadcrumbStack.unshift(item);
        buildStack();
        returnedOptions = item.descendants;
      }

      if (item.value === siblingId) {
        buildStack();
        returnedOptions = items;
      }

      if (item?.descendants?.length > 0) {
        findOptionsAndBuildBreadcrumbStack(buildStack, item, item.descendants);
      }
    }
    return [];
  };

  if (originOptions && (siblingId !== undefined || parentId !== undefined)) {
    findOptionsAndBuildBreadcrumbStack(undefined, undefined, originOptions);
    if (haveNotFoundSelectedOption(returnedOptions, originOptions)) {
      returnedOptions = originOptions;
    }
  } else {
    returnedOptions = originOptions;
  }

  allLevelsDescriptionPrefix = !!descriptionAllLevels
    ? breadcrumbStack.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.description + ' - ';
    }, '')
    : '';

  breadcrumbStack.unshift({ value: 0, description: '', type: linkType } as SelectItem);

  return {
    allLevelsDescriptionPrefix,
    breadcrumbStack,
    returnedOptions
  };
};
